import { axiosInstance } from "api/axios.instance"
import type { AxiosResponse } from "axios"
import type { TPricingSeries } from "types/modelNumbers.type"

class SeriesService {
	static SERIES = "series"

	async getSeries(): Promise<AxiosResponse<TPricingSeries[]>> {
		return axiosInstance.get(`${SeriesService.SERIES}/`)
	}
}

export default new SeriesService()
